export default __webpack_public_path__ + "static/media/PurpleCard.dfeedac1.svg";